import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InboxComponent } from './inbox.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditDialogComponent } from './edit-dialog/edit-dialog.component';
import { SabloaneComponent } from './sabloane/sabloane.component';
import { RedirectDialogComponent } from './redirect-dialog/redirect-dialog.component';
import { ActionHistoryDialogComponent } from './action-history-dialog/action-history-dialog.component';

@NgModule({
    declarations: [
        InboxComponent,
        EditDialogComponent,
        SabloaneComponent,
        RedirectDialogComponent,
        ActionHistoryDialogComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule
    ],
    exports: [InboxComponent],
})
export class InboxModule { }
